"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CertificateDownloadOptions = void 0;
var CertificateDownloadOptions;
(function (CertificateDownloadOptions) {
    CertificateDownloadOptions["ALL"] = "all";
    CertificateDownloadOptions["RANGE"] = "range";
})(CertificateDownloadOptions || (exports.CertificateDownloadOptions = CertificateDownloadOptions = {}));
//# sourceMappingURL=ICertificate.js.map